interface IExperienceData {
  label: string;
  percent: number;
}

export const feExperience: IExperienceData[] = [
  {
    label: 'HTML',
    percent: 90,
  },
  {
    label: 'CSS/SCSS',
    percent: 90,
  },
  {
    label: 'ReactJS',
    percent: 90,
  },
  {
    label: 'VueJS (Vue2/3)',
    percent: 80,
  },
  {
    label: 'Javascript',
    percent: 90,
  },
  {
    label: 'Typescript',
    percent: 80,
  },
];

export const beExperience: IExperienceData[] = [
  {
    label: 'NodeJS',
    percent: 80,
  },
  {
    label: 'ExpressJS',
    percent: 80,
  },
  {
    label: 'PHP',
    percent: 60,
  },
  {
    label: 'MySQL',
    percent: 60,
  },
  {
    label: 'MongoDB',
    percent: 70,
  },
];
